"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoCryptoPro = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Link_1 = require("@skbkontur/react-ui/components/Link");

var common_1 = require("../../utils/common");

var _1 = require(".");

exports.NoCryptoPro = function (_a) {
  var installDiskLink = _a.installDiskLink,
      trackEvent = _a.trackEvent;
  var currentUrlWithFlag = common_1.addParamsToLink(location.href, [{
    name: 'fixednocsp',
    value: '1'
  }]);
  var installDiskWithParams = common_1.addParamsToLink(installDiskLink, [{
    name: 'nocsp'
  }, {
    name: 'back',
    value: currentUrlWithFlag
  }]);

  var onInstallDiskClick = function onInstallDiskClick() {
    trackEvent(_1.DisplayedErrorCodes.NoCryptoPro, 'installDiskLinkClick');
  };

  return {
    title: 'Настройте компьютер',
    message: react_1.default.createElement("div", null, "\u0414\u043B\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F \u0440\u0430\u0431\u043E\u0442\u044B \u0441\xA0\u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430\u043C\u0438", ' ', react_1.default.createElement(Link_1.Link, {
      "data-tid": "installDiskLink",
      href: installDiskWithParams,
      onClick: onInstallDiskClick
    }, "\u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0435 \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u044B"), ".")
  };
};